import module from '@kendu/ui/module'
import template from './template.html'
import './style.scss'

export class kdDialogComponent {
  constructor ($element) {
    this.element = $element
  }

  $onInit () {
    this.element.attr('tabindex', 0)
    this.element[0].focus()
  }
}

module.component('kdDialog', {
  controller: kdDialogComponent,
  template: template,
  transclude: {
    header: '?kdDialogTitle',
    footer: '?kdDialogActions',
  },
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-dialog/component.js